export class FailedAttemptOtpModel {
    showViewOtpError: boolean;
    showViewLockOtp: boolean;
    numberOfAttemptsOtpCode: number;

    constructor(showViewOtpError?: boolean, showViewLockOtp?: boolean, numberOfAttemptsOtpCode?: number) {
        this.showViewOtpError = showViewOtpError ? showViewOtpError : false;
        this.showViewLockOtp = showViewLockOtp ? showViewLockOtp : false;
        this.numberOfAttemptsOtpCode = numberOfAttemptsOtpCode ? numberOfAttemptsOtpCode : 0;
    }
}